angular.module('gym.grading', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.grading', {
    abstract: true,
    url: '/grading',
    template: '<ui-view>'
  });
}]);
